import { Box, Typography, Stack, FormControl, Select, MenuItem } from "@mui/material";
import { Controller } from "react-hook-form";
import { FormCompanySectorSelector } from "src/components/Selector/CompanySectorSelector";
import type { Control, FieldErrors } from "react-hook-form";
import type { CompanyGridForm } from "./CompanySettingsForm";
import type { OrganizationType } from "src/types/organizationType";

type CompanyOrganizationSectionProps = {
    control: Control<CompanyGridForm>;
    errors: FieldErrors<CompanyGridForm>;
    organizationTypes: OrganizationType[];
};

export const CompanyOrganizationSection = (props: CompanyOrganizationSectionProps) => {
    const { control, errors, organizationTypes } = props;

    return (
        <Box>
            <Typography variant="h4" sx={{ lineHeight: "1.6em", color: "#393A36", marginBottom: "32px" }}>
                Organization
            </Typography>
            <Stack spacing="24px">
                {/* Two column layout for Company type and Industry sector */}
                <Box sx={{ display: "flex", gap: "24px" }}>
                    {/* Company type */}
                    <Box sx={{ width: "275px" }}>
                        <Typography variant="h6" sx={{ lineHeight: "1.6em", color: "#393A36", marginBottom: "8px" }}>
                            Company type* :
                        </Typography>
                        <Controller
                            name="organizationType"
                            control={control}
                            render={({ field: { ref, ...field } }) => (
                                <FormControl fullWidth>
                                    <Select
                                        {...field}
                                        displayEmpty
                                        variant="outlined"
                                        inputRef={ref}
                                        error={Boolean(errors.organizationType)}
                                        sx={{
                                            borderRadius: "24px",
                                            backgroundColor: "#FFFFFF",
                                            border: "1px solid #E7E6E4",
                                            height: "40px",
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "& .MuiSelect-select": {
                                                padding: "0px 12px 0px 20px",
                                                fontWeight: 500,
                                                fontSize: "0.875rem",
                                                color: "#393A36",
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            <span style={{ color: "#A3A2A0" }}>Select a company type</span>
                                        </MenuItem>
                                        {organizationTypes.map((orgType) => (
                                            <MenuItem key={orgType.id} value={orgType.id.toString()}>
                                                {orgType.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Box>

                    {/* Industry sector */}
                    <Box sx={{ width: "275px" }}>
                        <Typography variant="h6" sx={{ lineHeight: "1.6em", color: "#393A36", marginBottom: "8px" }}>
                            Industry sector :
                        </Typography>
                        <Controller
                            name="organizationSector"
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <FormCompanySectorSelector value={value || ""} onChange={onChange} />
                            )}
                        />
                    </Box>
                </Box>
            </Stack>
        </Box>
    );
};
